<template>
    <a-card style="max-width: 500px;margin: 0 auto;">
        <a-form-item>
            <a-alert :message="$t('message.typePw2ToContinue')" type="warning" show-icon />
        </a-form-item>
        <a-form
            ref="form"
            :model="formModel"
            @finish="onFinish"
            :rules="formRule"
            :scrollToFirstError="true"
            layout="vertical"
        >
            <a-form-item :label="$t('labelText.password2')" name="password2">
                <a-input-password ref="password2" v-model:value="formModel.password2" />
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.confirm') }}</a-button>
            </a-form-item>
        </a-form>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
    Button, Form, InputPassword, Card, Alert,
} from 'ant-design-vue';

import type { RuleObject } from 'ant-design-vue/lib/form';

import ApiRequest from '@/utils/ApiRequest';
import { RouteName, REDIRECT_QUERY_KEY } from '@/router';

interface FormModel {
    password2: string;
}

export default defineComponent({
    components: {
        AButton: Button,
        AForm: Form,
        AFormItem: Form.Item,
        AInputPassword: InputPassword,
        ACard: Card,
        AAlert: Alert,
    },

    setup() {
        const router = useRouter();
        const route = useRoute();

        const form = ref<typeof Form>();
        const password2 = ref<typeof InputPassword | null>(null);

        const formExtraError: Record<keyof FormModel, string> = {
            password2: '',
        };
        const formModel = reactive<FormModel>({
            password2: '',
        });
        const formRule = reactive<Record<keyof FormModel, RuleObject[]>>({
            password2: [
                {
                    required: true,
                    trigger: 'change',
                },
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    validator: (_rule: any, _value, callback) => callback(formExtraError[_rule.field as keyof FormModel] || undefined),
                },
            ],
        });

        const isLoading = ref(false);

        const onFinish = (values: FormModel) => {
            isLoading.value = true;

            ApiRequest.post('/auth-password2', values)
                .then(() => {
                    const redirect = route.query[REDIRECT_QUERY_KEY] as string;
                    if (redirect && redirect.length) {
                        // TODO: Check redirect is valid route
                        router.push(redirect);
                        return;
                    }

                    router.push({ name: RouteName.TOP });
                })
                .catch(err => {
                    ApiRequest.handleError(err, formExtraError, form.value);
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }

        onMounted(() => {
            password2.value?.focus();
        });

        return {
            RouteName,

            onFinish,

            formModel,
            formRule,

            isLoading,

            form,
            password2,
        };
    },
})
</script>
